export default "__VITE_ASSET__d4238b65__"